import { render, staticRenderFns } from "./PageCategoryList.vue?vue&type=template&id=b5a5659c"
import script from "./PageCategoryList.vue?vue&type=script&lang=js"
export * from "./PageCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports